import _ from 'lodash';
import React, { useMemo } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import DefaultSelectField from 'components/Utils/DefaultSelectField';
import ConcernRequirementBadge from './ConcernRequirementBadge';
import { useAppSelector } from 'careand-redux/store';
import { ConcernRequirement } from 'generated/api';

interface ConcernRequirementSelectorProps {
  label?: string;
  name?: string;
  value: string;
  onChange: (event: React.ChangeEvent<{ value: unknown }>) => void;
  /** IDs to exclude from the dropdown (already selected, etc.) */
  excludeIds?: string[];
  /** Extra items to append at the end of the dropdown */
  extraItems?: React.ReactNode;
  width?: string;
  style?: React.CSSProperties;
}

const ConcernRequirementSelector = ({
  label = 'Requirement',
  name,
  value,
  onChange,
  excludeIds = [],
  extraItems,
  width = '280px',
  style,
}: ConcernRequirementSelectorProps) => {
  const requirementsById = useAppSelector((state) => state.concernRequirements.byId);

  const allRequirements = useMemo(() => {
    return _(requirementsById).values().orderBy(['label'], ['asc']).value();
  }, [requirementsById]);

  const filteredRequirements = allRequirements.filter((r) => !excludeIds.includes(r.id!));

  return (
    <DefaultSelectField
      label={label}
      name={name}
      width={width}
      value={value}
      onChange={onChange}
      style={style}
      inputElements={[
        ...filteredRequirements.map((r) => (
          <MenuItem value={r.id} key={r.id} style={{ whiteSpace: 'normal', padding: '8px 16px' }}>
            <ConcernRequirementBadge requirement={r} />
          </MenuItem>
        )),
        ...(extraItems ? [extraItems] : []),
      ]}
    />
  );
};

export default ConcernRequirementSelector;
